/**
 * Включён ли биллинг (Polar). Пока не настроен — pricing-секция и пейвол скрыты,
 * премиум-гейты не блокируют пользователей (все считаются premium).
 *
 * Флаг `NEXT_PUBLIC_BILLING_ENABLED` читается и на сервере, и в клиентском
 * бандле (NEXT_PUBLIC_* инлайнится на этапе сборки). Поставить `true` после
 * настройки Polar (реальный POLAR_ACCESS_TOKEN).
 */
export function isBillingEnabled(): boolean {
	return process.env.NEXT_PUBLIC_BILLING_ENABLED === "true";
}
